import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../Styles/services.css';

export default class Services extends Component {
  render() {
    const services = [
      {
        icon: "fas fa-car-side",
        title: "All Types of Vehicles",
        description: "We provide a wide range of vehicles from luxury cars to tempo travelers, ensuring comfortable travel for individuals, families, and large groups. All vehicles are well-maintained with experienced chauffeurs.",
        features: ["Luxury Cars", "Tempo Travelers", "Mini Buses", "Luxury Buses"],
        color: "#ff6b35"
      },
      {
        icon: "fas fa-heart",
        title: "Honeymoon Packages",
        description: "Create unforgettable memories with our specially curated honeymoon packages. Enjoy romantic stays, candlelight dinners, and exclusive experiences in the most beautiful destinations.",
        features: ["Romantic Stays", "Candlelight Dinners", "Private Tours", "Spa Treatments"],
        color: "#ff4d6d"
      },
      {
        icon: "fas fa-users",
        title: "Group Tours",
        description: "Perfect for families, friends, and corporate groups. Our group tours offer customized itineraries, group discounts, and dedicated tour managers for a seamless experience.",
        features: ["Family Tours", "Corporate Groups", "College Tours", "Senior Citizen Tours"],
        color: "#4dabf7"
      },
      {
        icon: "fas fa-pray",
        title: "Pilgrim Tours",
        description: "Embark on spiritual journeys to sacred destinations across South India. We organize comfortable and hassle-free pilgrimage tours to temples, churches, and mosques.",
        features: ["Temple Tours", "Church Tours", "Mosque Visits", "Spiritual Retreats"],
        color: "#9775fa"
      },
      {
        icon: "fas fa-landmark",
        title: "Cultural Tours",
        description: "Immerse yourself in the rich cultural heritage of Kerala and South India. Experience traditional art forms, local festivals, and historical landmarks.",
        features: ["Kathakali Shows", "Traditional Crafts", "Local Festivals", "Historical Sites"],
        color: "#fcc419"
      },
      {
        icon: "fas fa-monument",
        title: "Heritage Tours",
        description: "Explore magnificent heritage sites, ancient temples, and historical monuments. Our heritage tours take you through centuries of rich history and architecture.",
        features: ["Ancient Temples", "Colonial Architecture", "Fort Visits", "Museum Tours"],
        color: "#e67700"
      },
      {
        icon: "fas fa-hiking",
        title: "Adventure Tours",
        description: "For the thrill-seekers, we offer exciting adventure activities including trekking, wildlife safaris, and water sports in the most scenic locations.",
        features: ["Trekking", "Wildlife Safaris", "Water Sports", "Rock Climbing"],
        color: "#51cf66"
      },
      {
        icon: "fas fa-graduation-cap",
        title: "Educational Tours",
        description: "Educational tours designed for schools and colleges, combining learning with fun. Visit historical sites, science centers, and cultural institutions.",
        features: ["School Tours", "College Tours", "Science Centers", "Historical Sites"],
        color: "#339af0"
      },
      {
        icon: "fas fa-lightbulb",
        title: "Enlightenment Journeys",
        description: "Transformative journeys focused on self-discovery, wellness, and spiritual growth. Includes yoga retreats, meditation camps, and wellness programs.",
        features: ["Yoga Retreats", "Meditation Camps", "Wellness Programs", "Ayurvedic Treatments"],
        color: "#a61e4d"
      },
      {
        icon: "fas fa-umbrella-beach",
        title: "Recreation Holidays",
        description: "Relax and rejuvenate with our recreational holiday packages. Perfect for beach holidays, hill station retreats, and leisure travel.",
        features: ["Beach Holidays", "Hill Station Retreats", "Leisure Travel", "Nature Walks"],
        color: "#20c997"
      },
      {
        icon: "fas fa-compass",
        title: "Special Interest Journeys",
        description: "Tailor-made journeys for specific interests including photography tours, culinary tours, and art expeditions across South India.",
        features: ["Photography Tours", "Culinary Tours", "Art Expeditions", "Bird Watching"],
        color: "#fd7e14"
      },
      {
        icon: "fas fa-chalkboard-user",
        title: "MICE Tourism",
        description: "Meetings, Incentives, Conferences, and Exhibitions (MICE) services with world-class venues, accommodation, and event management support.",
        features: ["Corporate Meetings", "Incentive Tours", "Conferences", "Exhibitions"],
        color: "#5f3dc6"
      },
      {
        icon: "fas fa-ring",
        title: "Destination Weddings",
        description: "Make your special day extraordinary with our destination wedding services. Choose from beach weddings, resort weddings, or traditional Kerala weddings.",
        features: ["Beach Weddings", "Resort Weddings", "Traditional Weddings", "Wedding Planning"],
        color: "#e64980"
      },
      {
        icon: "fas fa-fish",
        title: "Village Tours",
        description: "Experience authentic village life with our unique village tours. Enjoy fishing, village walks, country boating, and traditional village activities.",
        features: ["Fishing", "Village Walks", "Country Boating", "Village Activities"],
        color: "#94d82d"
      }
    ];

      return (
      <div className="kairaly-services-page">
        {/* Hero Section */}
        <div className="kairaly-services-hero">
          <div className="kairaly-services-hero-overlay"></div>
          <div className="kairaly-services-hero-content">
            <h1 className="kairaly-services-hero-title">Our Services</h1>
            <p className="kairaly-services-hero-subtitle">
              With us you'll find a perfect destination among hundreds available
            </p>
            <div className="kairaly-services-stats">
              <div className="stat">
                <span className="stat-number">14+</span>
                <span className="stat-label">Service Categories</span>
              </div>
              <div className="stat">
                <span className="stat-number">5000+</span>
                <span className="stat-label">Happy Customers</span>
              </div>
              <div className="stat">
                <span className="stat-number">50+</span>
                <span className="stat-label">Destinations</span>
              </div>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="kairaly-services-container">
          <div className="kairaly-services-intro">
            <h2 className="kairaly-services-section-title">What We Offer</h2>
            <p className="kairaly-services-section-subtitle">
              Comprehensive travel solutions tailored to your needs
            </p>
          </div>

          <Grid>
            <Row className="kairaly-services-grid">
              {services.map((service, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="kairaly-service-col">
                  <div className="kairaly-service-card" style={{ borderTopColor: service.color }}>
                    <div className="kairaly-service-icon-wrapper" style={{ background: `${service.color}20` }}>
                      <i className={`fas ${service.icon} kairaly-service-icon`} style={{ color: service.color }}></i>
                    </div>
                    <h3 className="kairaly-service-title">{service.title}</h3>
                    <p className="kairaly-service-description">{service.description}</p>
                    <div className="kairaly-service-features">
                      {service.features.map((feature, idx) => (
                        <span key={idx} className="kairaly-feature-tag">{feature}</span>
                      ))}
                    </div>
                    <Link to="/contact" className="kairaly-service-btn">
                      <span>Enquire Now</span>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </Link>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>

          {/* Call to Action */}
          <div className="kairaly-services-cta">
            <div className="kairaly-cta-content">
              <h3>Ready to Plan Your Journey?</h3>
              <p>Contact us today for personalized travel solutions</p>
              <Link to="/contact" className="kairaly-cta-button">
                Get in Touch
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}